import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Iframe from 'react-iframe';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import Fab from '@material-ui/core/Fab';
import ExploreOutlinedIcon from '@material-ui/icons/ExploreOutlined';



const MapSection = styled.section`
    padding-bottom:20px;
    background-color:#fffbf0;
    width:80%;
    max-width:100%;
    display:block;

    @media (max-width:${props => props.theme.breakpoints.md}) {
        width:100%;
    }

    @media (min-width:${props => props.theme.breakpoints.sm}) {
        display:inline-block;
    }
`;
const TitleBox = styled.div`
    padding:20px;
    h2 {
        color:#795548;
        padding-bottom:40px;
        
    }
    h3 {
        margin-bottom:20px;
        padding-bottom:40px;
    }
    padding-top:0px;
`;

const PlaceSection = ({ index }) => (
    <MapSection>
    {index 
        &&
        <TitleBox>
        <h2><RoomOutlinedIcon color="primary"/>&nbsp;地图在这里&nbsp;<RoomOutlinedIcon color="secondary"/></h2>
        <h3>我们店在这个位置</h3>
        <Fab variant="extended" style={{backgroundColor:"#536dfe"}} color="primary" href="/partyway">到我们点的路程&nbsp;<ExploreOutlinedIcon /></Fab>
        <br /><br />
        </TitleBox>
    }
        <Iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14775.70247092121!2d114.0272414!3d22.2049329!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd7ed25240a230015!2z5Zac5qiC5bCP5bqX!5e0!3m2!1sja!2sjp!4v1600626848743!5m2!1sja!2sjp"
        width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0" styles={{ borderRadious:"100px" }} />
    </MapSection>
);

export default PlaceSection;

PlaceSection.propTypes = {
    index:PropTypes.bool.isRequired,
}
